const mEditionMapActivationSendingOfDeliverablesModalDelete = {
  mEditionMapActivationSendingOfDeliverablesModalDelete: {
    alerts: {
      deleteContenidoEntregable: {
        error: 'Un error ha ocurrido. Vuelve a intentarlo en un momento.',
        success: 'El entregable se eliminó exitosamente.'
      }
    },

    buttonCancel: 'CANCELAR',
    buttonPrimary: 'ELIMINAR',

    messageDelete: {
      element: 'Se eliminará el entregable ',
      options: 'y todas sus características de forma definitiva.',
      notReversed: 'Esta acción no podrá ser revertida.'
    },

    title: 'Eliminar Entregable'
  }
}

export default mEditionMapActivationSendingOfDeliverablesModalDelete
